import PlannerDriverPlanListParams, {
  PlannerDriverPlanListParamsPlanType,
  PlannerDriverPlanListParamsSorter,
  PlannerDriverPlanListParamsSorterType,
} from "../../../../../common/services/planner/list/planner-driver-plan-list-params";
import PlanningOrderDriverPlanListingFilter, {
  PlanningOrderDriverPlanListingAddressFilter,
  PlanningOrderDriverPlanListingCargoOrderFilter,
  PlanningOrderDriverPlanListingDriverNameFilter,
  PlanningOrderDriverPlanListingResultFilter,
  PlanningOrderDriverPlanListingResultFilterValue,
} from "./planning-order-driver-plan-listing-filter";
import PlanningOrderDriverPlanListingFilterType from "./planning-order-driver-plan-listing-filter-type";
import PlanningOrderDriverPlanListingSortKey from "./planning-order-driver-plan-listing-sort-key";

const createSort = (
  sort: PlanningOrderDriverPlanListingSortKey,
): PlannerDriverPlanListParamsSorter => {
  switch (sort) {
    case PlanningOrderDriverPlanListingSortKey.DRIVER_NAME_ASC:
      return {
        sorterType: PlannerDriverPlanListParamsSorterType.DRIVER_NAME_ASC,
      };
    case PlanningOrderDriverPlanListingSortKey.DRIVER_NAME_DESC:
      return {
        sorterType: PlannerDriverPlanListParamsSorterType.DRIVER_NAME_DESC,
      };
    case PlanningOrderDriverPlanListingSortKey.ROUTE_END_DATE_ASC:
      return {
        sorterType: PlannerDriverPlanListParamsSorterType.END_DATE_ASC,
      };
    case PlanningOrderDriverPlanListingSortKey.ROUTE_END_DATE_DESC:
      return {
        sorterType: PlannerDriverPlanListParamsSorterType.END_DATE_DESC,
      };
    case PlanningOrderDriverPlanListingSortKey.ROUTE_START_DATE_ASC:
      return {
        sorterType: PlannerDriverPlanListParamsSorterType.START_DATE_ASC,
      };
    case PlanningOrderDriverPlanListingSortKey.ROUTE_START_DATE_DESC:
      return {
        sorterType: PlannerDriverPlanListParamsSorterType.START_DATE_DESC,
      };
  }
};

const createPlanType = (
  resultFilterValue:
    | PlanningOrderDriverPlanListingResultFilterValue
    | undefined,
): PlannerDriverPlanListParamsPlanType[] => {
  switch (resultFilterValue) {
    case PlanningOrderDriverPlanListingResultFilterValue.EXISTING_PLAN:
      return [PlannerDriverPlanListParamsPlanType.EXISTING_PLAN];
    case PlanningOrderDriverPlanListingResultFilterValue.NEW_PLAN:
      return [PlannerDriverPlanListParamsPlanType.NEW_PLAN];
    default:
      return [
        PlannerDriverPlanListParamsPlanType.EXISTING_PLAN,
        PlannerDriverPlanListParamsPlanType.NEW_PLAN,
      ];
  }
};

const create = (
  filters: PlanningOrderDriverPlanListingFilter[],
  sortKey: PlanningOrderDriverPlanListingSortKey,
  page: number,
  pageSize: number,
  orderUuid: string,
): PlannerDriverPlanListParams => {
  const addressFilterValue = filters.find(
    (filter) =>
      filter.type === PlanningOrderDriverPlanListingFilterType.ADDRESS,
  )?.value as PlanningOrderDriverPlanListingAddressFilter["value"] | undefined;

  const driverNameFilterValue = filters.find(
    (filter) =>
      filter.type === PlanningOrderDriverPlanListingFilterType.DRIVER_NAME,
  )?.value as
    | PlanningOrderDriverPlanListingDriverNameFilter["value"]
    | undefined;

  const cargoOrderFilterValue = filters.find(
    (filter) =>
      filter.type === PlanningOrderDriverPlanListingFilterType.CARGO_ORDER,
  )?.value as
    | PlanningOrderDriverPlanListingCargoOrderFilter["value"]
    | undefined;

  const resultFilterValue = filters.find(
    (filter) => filter.type === PlanningOrderDriverPlanListingFilterType.RESULT,
  )?.value as PlanningOrderDriverPlanListingResultFilter["value"] | undefined;

  return {
    address: addressFilterValue
      ? {
          query: addressFilterValue.address,
          dateFrom: addressFilterValue.startDate,
          dateTo: addressFilterValue.endDate,
        }
      : undefined,
    orderUuid,
    page,
    pageSize,
    driverName: driverNameFilterValue,
    orderQuery: cargoOrderFilterValue,
    planType: createPlanType(resultFilterValue),
    sort: createSort(sortKey),
  };
};

const planningOrderDriverPlanListingDriverPlanListLoadParamsFactory = {
  create,
};

export default planningOrderDriverPlanListingDriverPlanListLoadParamsFactory;
